import { api } from './client'

export interface Bot {
  id: string
  username: string
  name: string
  description: string
  about: string
  avatar_file_id: string
  is_active: boolean
  supports_inline: boolean
  is_public: boolean
  category: string
  rating: number
  install_count: number
  web_app_url: string
  created_at: string
}

export interface BotCommand {
  bot_id: string
  command: string
  description: string
  scope: string
  language: string
}

export interface InlineQueryResult {
  type: string
  id: string
  title?: string
  description?: string
  url?: string
  thumb_url?: string
  photo_url?: string
  gif_url?: string
  input_message_content?: { message_text?: string }
}

export const botsApi = {
  get: (botId: string): Promise<Bot> =>
    api.get(`/v1/bots/${botId}`),

  getCommands: (botId: string): Promise<{ commands: BotCommand[] }> =>
    api.get(`/v1/bots/${botId}/commands`),

  search: (q: string, limit = 20): Promise<{ bots: Bot[] }> =>
    api.get(`/v1/bots/store/search?q=${encodeURIComponent(q)}&limit=${limit}`),

  list: (category?: string, limit = 20): Promise<{ bots: Bot[] }> =>
    api.get(`/v1/bots/store/list${category ? `?category=${encodeURIComponent(category)}` : ''}${category ? '&' : '?'}limit=${limit}`),

  inlineQuery: (botId: string, query: string, chatType = ''): Promise<{ results: InlineQueryResult[] }> =>
    api.post(`/v1/bots/${botId}/inline`, { query, chat_type: chatType }),

  rate: (botId: string, score: number): Promise<void> =>
    api.post(`/v1/bots/store/${botId}/rate`, { score }),

  listMine: (): Promise<{ bots: Bot[] }> =>
    api.get('/v1/bots/'),

  create: (data: { username: string; name: string; description?: string; is_public?: boolean; category?: string; web_app_url?: string }): Promise<Bot & { token: string }> =>
    api.post('/v1/bots/', data),

  update: (botId: string, data: Partial<{ name: string; description: string; is_public: boolean; category: string; web_app_url: string }>): Promise<Bot> =>
    api.put(`/v1/bots/${botId}`, data),

  deleteBot: (botId: string): Promise<void> =>
    api.delete(`/v1/bots/${botId}`),

  regenerateToken: (botId: string): Promise<{ token: string }> =>
    api.post(`/v1/bots/${botId}/token/regenerate`, {}),
}
